import React from 'react';
import { Chip } from '@mui/material';
import { TicketStatus } from 'src/interfaces/TicketTypes';

const statusLabels: Record<number, string> = {
  [TicketStatus.Open]: 'Open',
  [TicketStatus.InProgress]: 'In Progress',
  [TicketStatus.Escalated]: 'Escalated',
  [TicketStatus.Resolved]: 'Resolved',
  [TicketStatus.Closed]: 'Closed'
};

const statusColors: Record<
  number,
  'error' | 'warning' | 'info' | 'success' | 'default'
> = {
  [TicketStatus.Open]: 'error',
  [TicketStatus.InProgress]: 'warning',
  [TicketStatus.Escalated]: 'error',
  [TicketStatus.Resolved]: 'success',
  [TicketStatus.Closed]: 'default'
};

interface StatusChipProps {
  status: number;
  size?: 'small' | 'medium';
}

function StatusChip({ status, size = 'small' }: StatusChipProps) {
  return (
    <Chip
      label={statusLabels[status] ?? 'Unknown'}
      color={statusColors[status] ?? 'default'}
      size={size}
    />
  );
}

export default StatusChip;